import React, { useEffect, useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { v4 as uuid } from 'uuid';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { useToast } from '../../../hooks/toast';
import Input from '../../Inputs/Input';
import InputDate from '../../Inputs/InputDate';
import InputSelectMktCanal from '../../Inputs/Selects/InputSelectMktCanal';
import Button from '../../Button';
import getValidationErrors from '../../../utils/getValidationErrors';
import ComboBox from '../../Inputs/ComboBox';
import { formatPrice } from '../../../utils/format';

import { Container, Content, /* ModalContent , */ FormView } from './styles';

type CampanhaData = {
  date_f: string;
  date_i: string;
  descricao: string;
  id: string;
  id_canal: string;
  id_influencer: number;
  url: string;
  valor: number;
}
type CanalData = {
  codcam: number;
  nomcam: string;
}
type InfluencersData = {
  cidade: string;
  value: number;
  label: string;
}
type FormData = {
	id_canal: number;
	id_influencer: string;
	date_i: string;
	date_f: string;
	descricao: string;
	valor: string;
}
interface ModalParams {
	id?: string;
	onClose: any;
	campanha?: CampanhaData;
	handleGetCampanhas?: any;
	canal: string;
}

const ModalCadCampanha: React.FC<ModalParams> = ({
  // id = 'ModalCadCampanha',
  onClose = () => {},
  campanha,
  handleGetCampanhas,
  canal,
}) => {
  /* const handleOutSideClick = useCallback(
    e => {
      if (e.target.id === id) {
        onClose();
      }
    },
    [id, onClose],
  ); */
  const formRef = useRef<FormHandles>(null);
  const { company } = useAuth();
  const { addToast } = useToast();

  const [canais, setCanais] = useState<CanalData[]>([]);
  const [influencers, setInfluencers] = useState<InfluencersData[]>([]);
  const [campanhaEditar, setCampanhaEditar] = useState<CampanhaData>(
    {} as CampanhaData,
  );

  useEffect(() => {
    api.get('portal/campanha/index_mkt').then(response => {
      setCanais(response.data.canais);
      setInfluencers(response.data.influencers);

      if (campanha?.id) {
        campanha.id_canal = campanha.id_canal.toString();

        setCampanhaEditar(campanha);

        formRef.current?.setFieldValue('id_canal', campanha.id_canal);
        formRef.current?.setFieldValue('valor', formatPrice(campanha.valor));
      }
    });
  }, [campanha, canal]);

  const handleSubmit = useCallback(
		async (data: FormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          id_canal: Yup.number().required('E-mail obrigatório'),
          id_influencer: Yup.string().required(
            'Código da Influencer obrigatório',
          ),
          date_i: Yup.string().required('Data inicial obrigatório'),
          date_f: Yup.string().required('Data final obrigatório'),
          descricao: Yup.string(),
          valor: Yup.string(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const {
          id_canal,
          valor,
          id_influencer,
          date_i,
          date_f,
          descricao,
        } = data;

        const auxValor = valor
          .replace('R$ ', '')
          .replace('.', '')
          .replace(',', '.');

        const uid = campanha?.id ? campanha.id : uuid();

        const formData = {
          id: uid,
          id_canal: id_canal,
          id_influencer: parseInt(id_influencer.split(' -', 1)[0]),
          date_i,
          date_f,
          descricao,
          valor: parseFloat(auxValor),
          url: `https://cardapio.razio.com.br/cardapio/${company.url_page}?campaign=${uid}`,
        };

        await api.post('portal/campanha/store', formData).then(response => {
          if (response.data.che === 'N') {
            addToast({
              type: 'error',
              title: 'Erro na autenticação',
              description: `${response.data.men}`,
            });
          }

          handleGetCampanhas();

          addToast({
            type: 'success',
            title: 'Cadastro Promoção',
            description: `${response.data.men}`,
          });

          setCampanhaEditar({} as CampanhaData);
          onClose();
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro, cheque os campos.',
        });
      }
    },
    [addToast, company, campanha, handleGetCampanhas, onClose],
  );

  const handleFormatMoeda = useCallback(() => {
    let moedastr = formRef.current?.getFieldValue('valor');
    // moedastr = moedastr.replace(/\D/g, '');
    // eliminar todos os caracteres nao-numeros.
    moedastr = moedastr.replace(/[^0-9]/g, '');

    if (moedastr) {
      const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));
      let tmp = `${moeda}`;

      tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
      if (tmp.length >= 7) {
        // antigo
        // tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
        // novo
        tmp = tmp.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
      }

      formRef.current?.setFieldValue('valor', `R$ ${tmp}`);
    } else {
      moedastr = moedastr.replace(/\D/g, '');
      formRef.current?.setFieldValue('valor', `${moedastr}`);
    }
  }, []);

  return (
    <Container id="ModalCadCampanha">
      {' '}
      {/* onClick={handleOutSideClick}> */}
      <Content>
        <h1>Cadastro de Campanha</h1>

        <FormView
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={campanhaEditar}
        >
          <div className="input">
            <p>
              Canal{' '}
              <span>
                (obrigatório<span className="span-obr">*</span>)
              </span>
            </p>
            <InputSelectMktCanal
              name="id_canal"
              placeholder="Canal"
              options={canais}
              defaultValue={''}
              containerStyle={{ padding: '5px 10px' }}
            />
          </div>

          <div className="input">
            <p>
              Código influencer{' '}
              <span>
                (obrigatório<span className="span-obr">*</span>)
              </span>
            </p>

            <ComboBox
              name="id_influencer"
              placeholder="Influencer"
              options={influencers}
            />
          </div>

          <div className="input">
            <p>
              Data Inicial{' '}
              <span>
                (obrigatório<span className="span-obr">*</span>)
              </span>
            </p>
            <InputDate name="date_i" />
          </div>

          <div className="input">
            <p>
              Data Final{' '}
              <span>
                (obrigatório<span className="span-obr">*</span>)
              </span>
            </p>
            <InputDate name="date_f" />
          </div>

          <div className="input">
            <p>
              Descrição <span>(opcional)</span>
            </p>
            <Input name="descricao" type="text" placeholder="Descrição" />
          </div>

          <div className="input">
            <p>
              Valor de custo <span>(opcional)</span>
            </p>
            <Input
              name="valor"
              type="text"
              placeholder="Valor de custo"
              onChange={handleFormatMoeda}
              maxLength={23}
            />
          </div>

          <Button type="submit">{campanha?.id ? 'Editar' : 'Cadastrar'}</Button>
          <Button className="btn-cancel" onClick={onClose}>
            Cancelar
          </Button>
        </FormView>
      </Content>
    </Container>
  );
};

export default ModalCadCampanha;
